import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiTrendingUp, FiClock, FiDollarSign } = FiIcons;

const stats = [
  {
    icon: FiZap,
    number: '92%',
    label: 'Faster Production',
    description: 'Average time saved vs manual creation',
    color: 'text-brand-electric',
    bgColor: 'bg-brand-electric/20'
  },
  {
    icon: FiTrendingUp,
    number: '4.8/5',
    label: 'User Rating',
    description: 'Based on 1,200+ verified reviews',
    color: 'text-brand-gold',
    bgColor: 'bg-brand-gold/20'
  },
  {
    icon: FiClock,
    number: '15 min',
    label: 'Average Transform Time',
    description: 'From video URL to finished course',
    color: 'text-brand-mint',
    bgColor: 'bg-brand-mint/20'
  },
  {
    icon: FiDollarSign,
    number: '$40k+',
    label: 'Revenue Generated',
    description: 'Average monthly by agencies',
    color: 'text-brand-neon',
    bgColor: 'bg-brand-neon/20'
  }
];

const Testimonials = () => {
  return (
    <section className="py-28 bg-gradient-to-b from-brand-dark via-brand-card/10 to-brand-dark border-y border-white/5 relative overflow-hidden">
      {/* Decorative separators */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/50 to-transparent"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-neon/5 via-transparent to-brand-electric/5 pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <FadeIn className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-6xl font-black mb-6 text-white">Trusted by creators worldwide</h2>
          <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto">Real impact. Measurable results.</p>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
          {stats.map((stat, idx) => (
            <FadeIn key={idx} delay={idx * 0.1}>
              <div className="glass-card p-6 md:p-8 text-center border border-white/10 hover:border-brand-electric/40 transition-all hover:shadow-[0_0_30px_rgba(0,229,255,0.2)] group">
                <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl ${stat.bgColor} border border-white/10 flex items-center justify-center mx-auto mb-4 md:mb-6 shadow-lg group-hover:scale-110 transition-transform`}>
                  <SafeIcon icon={stat.icon} className={`text-2xl md:text-3xl ${stat.color}`} />
                </div>
                <div className={`text-3xl md:text-4xl font-black ${stat.color} mb-2 drop-shadow-[0_0_15px_currentColor]`}>
                  {stat.number}
                </div>
                <div className="text-base md:text-lg font-bold text-white mb-2">{stat.label}</div>
                <p className="text-xs md:text-sm text-white/60">{stat.description}</p>
              </div>
            </FadeIn>
          ))}
        </div>

        {/* Live Activity Feed */}
        <FadeIn className="max-w-4xl mx-auto glass-card p-6 md:p-8 border border-white/10">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg md:text-xl font-bold text-white flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-brand-electric animate-pulse shadow-[0_0_10px_rgba(0,229,255,0.8)]"></div>
              Live Transformations
            </h3>
            <span className="text-xs md:text-sm text-white/60">Updated in real-time</span>
          </div>
          
          <div className="space-y-3">
            {[
              { user: 'Sarah K.', action: 'transformed a 45-min webinar', time: '2 min ago', location: 'New York' },
              { user: 'Marcus T.', action: 'created 12 courses from playlist', time: '5 min ago', location: 'London' },
              { user: 'Jessica M.', action: 'generated motion video slides', time: '8 min ago', location: 'San Francisco' },
              { user: 'Dr. Raj P.', action: 'cloned voice for 20 videos', time: '12 min ago', location: 'Mumbai' }
            ].map((activity, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 md:p-4 bg-white/5 rounded-lg border border-white/5 hover:border-brand-electric/30 transition-all">
                <div className="flex items-center gap-3 md:gap-4">
                  <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-border overflow-hidden ring-2 ring-brand-electric/40">
                    <img src={`https://i.pravatar.cc/100?img=${idx + 30}`} alt={activity.user} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="text-sm md:text-base text-white font-medium">
                      <span className="text-brand-electric">{activity.user}</span> {activity.action}
                    </p>
                    <p className="text-xs text-white/50">{activity.location}</p>
                  </div>
                </div>
                <span className="text-xs text-white/40 hidden sm:inline">{activity.time}</span>
              </div>
            ))}
          </div>
        </FadeIn>

      </div>
    </section>
  );
};

export default Testimonials;